import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { CustomerNote } from '../../../collections/candidates/notes/note.interface';
export class CustomerNoteService {
   async post(id: number, note: CustomerNote) {
      const response = await http.post<ApiResource<CustomerNote>>(`/customers/${id}/notes`, note);
      return response.data;
   }
   async delete(customer_id: number, id: number) {
      const response = await http.delete<ApiResource<CustomerNote>>(`/customers/${customer_id}/notes/${id}`);
      return response.data;
   }
   async put(id: number, noteId: number, note: CustomerNote) {
      const response = await http.put<ApiResource<CustomerNote>>(`/customers/${id}/notes/${noteId}`, note);
      return response.data;
   }
}
